<template>
  <v-card elevation="0" tile class="address-list pa-1" :loading="loading">

    <div v-if="!loading">
      <v-card class="pa-3 mb-2" v-for="(addr, i) in address" :key="i" outlined>
        <v-row align="center" class="spacer" no-gutters>
          <v-col cols="4" sm="3" md="3" class="text-uppercase">
            <strong v-if="addr.id" v-html="addr.label"></strong><span v-else><em>{{ $t('accountSettings.address.newAdress')
            }}</em></span></v-col>
          <v-col class="d-flex" sm="7" md="8">
            <div>
              <div><span v-html="addr.resume" class="limited-field"></span></div>
              <div class="font-italic text-caption" v-if="addr.main" v-html="$t('accountSettings.address.main')"></div>
            </div>
          </v-col>
          <v-col cols="12" sm="2" md="1">
            <div class="d-flex">
              <v-spacer></v-spacer>
              <v-btn icon @click="editAddress(addr)"><v-icon>mdi-pencil</v-icon></v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div class="my-3" v-if="!loading && !address.length">
      <v-alert type="error" outlined>{{ $t('accountSettings.address.notFound') }}</v-alert>
      <!-- <div v-else></div> -->

    </div>
    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn v-if="!loading" class="mx-auto" color="success" elevation="0" @click="addAddress()"
        :disabled="hasDocNotDone"><v-icon>mdi-plus</v-icon>{{ $t('accountSettings.address.btnAdd') }}</v-btn>
    </div>
    <!-- <v-snackbar style="top: 70px" top right v-model="messages.show" color="success">
      <span v-html="messages.text"></span>
      <template v-slot:action="{ attrs }">
        <v-btn icon dark small v-bind="attrs" @click="messages.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar> -->
    <!-- <v-snackbar style="top: 70px" top right v-model="errors.show" color="error">
      <span v-html="errors.text"></span>
      <template v-slot:action="{ attrs }">
        <v-btn icon dark small v-bind="attrs" @click="errors.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar> -->
    <v-dialog v-model="snap.show" width="900">
      <v-card class="mx-auto pa-6">
        <v-card-title v-if="snap && snap.form && snap.form.id">
          {{ $t('accountSettings.address.editAddress') }}
          <v-spacer></v-spacer>
          <v-btn white icon @click="snap.show = false" ><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-title v-else>
          {{ $t('accountSettings.address.newAdress') }}
          <v-spacer></v-spacer>
          <v-btn white icon @click="snap.show = false" ><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <address-form v-if="snap.show" :address-counter="address.length" :item="snap.form" @cancel="cancel($event)" @remove="remove($event)"
            @update="update($event)" @add-address="update($event)"></address-form>
        </v-card-text>

      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import AddressForm from "./AddressForm.vue";
export default {
  name: "AddressList",
  components: {
    AddressForm,
  },
  data() {
    return {
      snap: {
        show: false,
        form: null
      },
      current: undefined,
      address: [],
      errors: {
        show: false,
        text: "",
      },
      // messages: {
      //   show: false,
      //   text: "",
      // },
      model: {
        label: "",
        street: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
        zipCode: "",
        contactTypeId: 1,
      },
      loading: false,
    };
  },
  mounted() {
    this.fetchDocuments();
  },
  computed: {
    hasDocNotDone() {
      if (!this.address.length) return false;
      const addr = this.address[this.address.length - 1];
      return addr && addr.id ? false : true;
    },
    showAdd() {
      return (
        !this.hasDocNotDone &&
        !this.loading &&
        typeof this.current == "undefined"
      );
    },
  },
  methods: {

    ...mapActions("snackbar",["showSnack"]),

    cancel() {
      this.snap.show = false
    },
    remove() {
      this.snap.show = false
      const address = JSON.parse(JSON.stringify(this.model));
      this.snap.form = address
      this.fetchDocuments()
      this.showSnack({
            text: this.$t("accountSettings.address.success.addressRemove"),
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
    },
    update() {  
      this.snap.show = false
       if(this.snap.form.id){
        this.showSnack({
            text: this.$t("accountSettings.address.success.attAddress"),
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
      }else{
        this.showSnack({
            text: this.$t("accountSettings.address.success.addAddress"),
            color: "success",
            timeout: 3800,
            icon: "mdi-check",
          });
      }
      
      this.fetchDocuments()

    },
    addAddress() {
      const address = JSON.parse(JSON.stringify(this.model));
      this.snap.form = address
      this.snap.show = true
    },
    editAddress(form) {
      this.snap.form = JSON.parse(JSON.stringify(form))
      console.log('FORM', form)
      this.snap.show = true
    },
    fetchDocuments() {
      this.loading = true;
      console.log('headers', this.$root.authToken)
      const url = `address`;
      this.$axios
        .get(url, {headers: {}, data: {}})
        .then(
          (result) => {
            let addresses = [];
            result.data.data.forEach((addr) => {
              addr.resume = `${addr.street} ${addr.number} - ${addr.district} - ${addr.city}`;
              addresses.push(addr);
            });
            this.address = addresses;
            this.loading = false;
          },
          (err) => {
            console.error("error on fetch address", err);
            this.loading = false;
          }
        );
    },
  },
};
</script>
<style lang="scss">
.address-list {
  .v-expansion-panel-header>*:not(.v-expansion-panel-header__icon) {
    max-width: calc(100% - 30px);
  }
}

.limited-field {
  overflow: hidden;
  white-space: nowrap;
  padding-right: 10px;
  position: relative;
  display: block;
  width: inherit;
  max-width: calc(100% - 90px);
}

.limited-field::before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%);
  width: 100px;
  margin-top: -5px;
  height: calc(100% + 10px);
}
</style>